if (!customElements.get('stock-dispatch-status')) {
  customElements.define(
    'stock-dispatch-status',
    class StockDispatchStatus extends HTMLElement {
      connectedCallback() {
        const dispatchCopy = this.querySelector('[data-stock-dispatch-copy]');
        if (!dispatchCopy) return;

        const parts = new Intl.DateTimeFormat('en-AU', {
          timeZone: 'Australia/Sydney',
          weekday: 'short',
          hour: '2-digit',
          hourCycle: 'h23',
        }).formatToParts(new Date());

        const weekday = parts.find((part) => part.type === 'weekday')?.value;
        const hour = Number(parts.find((part) => part.type === 'hour')?.value || 0);

        if (weekday === 'Sat' || weekday === 'Sun') {
          dispatchCopy.textContent = this.dataset.dispatchMonday;
          return;
        }

        if (weekday === 'Fri' && hour >= 14) {
          dispatchCopy.textContent = this.dataset.dispatchMonday;
          return;
        }

        dispatchCopy.textContent =
          hour < 14 ? this.dataset.dispatchSameDay : this.dataset.dispatchNextBusinessDay;
      }
    }
  );
}
